const ChevronRight = ({clr, height, width}) => (
<svg xmlns="http://www.w3.org/2000/svg" width={width || 6} height={height ||8} viewBox="0 0 5 8" fill="none">
    <path
      fill={clr || "#BABABA"}
      d="M3.617 3.983.325.691 1.017 0 5 3.983 1.017 8l-.692-.691"
    />
  </svg>
)

export default ChevronRight